// Auto-generated by typewriter from C# model
export enum IcmIncidentSeverity {
    Sev0 = 0,
    Sev1 = 1,
    Sev2 = 2,
    Sev3 = 3,
    Sev4 = 4,
    Sev25 = 25
}
